import { DataSource, CollectionViewer } from '@angular/cdk/collections';
import { SortFilterInterface } from '../../../../../model/sort-filter';
// See C001 - 2026-04-17 - HE
// import { LoggingService } from '../../../../../services.module';
import { LoggingService } from '../../../../../services/logging.service';
import { ApplicationAuditLog } from '../../../../../model/application-audit-log';
import { ApplicationAuditLogAPI } from '../../../../../services/logging.service';
import { BehaviorSubject, finalize, Observable } from 'rxjs';

export class ApplicationLogTableDataSource extends DataSource<ApplicationAuditLog> {
  private applicationLogSubject$ = new BehaviorSubject<ApplicationAuditLog[]>([]);

  private loadingSubject$ = new BehaviorSubject<boolean>(false);

  public loading$ = this.loadingSubject$.asObservable();

  // to show the total number of records
  private countSubject = new BehaviorSubject<number>(0);
  public counter$ = this.countSubject.asObservable();

  constructor(private _loggingService: LoggingService) {
    super();
  }

  loadApplicationLogs(
    applicationId: string,
    pageIndex: number,
    pageSize: number,
    sortActive: string,
    sort: string,
    sortFilter: SortFilterInterface
  ) {
    this.loadingSubject$.next(true);
    this._loggingService
      .getApplicationAuditLogs(applicationId, pageIndex, pageSize, sortActive, sort, sortFilter)
      .pipe(
        // catchError(() => of([])),
        finalize(() => this.loadingSubject$.next(false))
      )
      .subscribe((data: ApplicationAuditLogAPI) => {
        console.log('load Application Logs');
        console.log(data);
        console.log('----------------------------');
        this.applicationLogSubject$.next(data.items);
        this.countSubject.next(data.total_count);
        this.loadingSubject$.next(false);
      });
  }

  /**
   * Connect this data source to the table. The table will only update when
   * the returned stream emits new items.
   * @returns A stream of the items to be rendered.
   */
  connect(collectionViewer: CollectionViewer): Observable<ApplicationAuditLog[]> {
    return this.applicationLogSubject$.asObservable();
  }

  /**
   *  Called when the table is being destroyed. Use this function, to clean up
   * any open connections or free any held resources that were set up during connect.
   */
  disconnect(collectionViewer: CollectionViewer) {
    this.applicationLogSubject$.complete();
    this.loadingSubject$.complete();
    this.countSubject.complete();
  }
}

// ========================================
// CHANGE LOG
// ========================================
// C001: Changed LoggingService import from '../../../../../services.module' to '../../../../../services/logging.service'. Previous behavior: Invalid import of LoggingService from services.module (not a public export), causing TS2459 during ApplicationLogTableDataSource compilation. New behavior: Import from logging.service.ts. Reason: Align with ApplicationLogTableComponent fix and restore build. Context: Application log table datasource. Impact: Type-only / constructor typing fix for the datasource class. - 2026-04-17 - HE
